var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var signupDialog = require('js/lib/notifications/sw-signup-dialog');
var notifications = require('js/lib/notifications/sw-notifications');

var addToCartattribute = 'data-sw-custom-model-product-page-add-to-cart';

$(document).ready(function() {

  $('body').on('click', '[' + addToCartattribute + ']', function(e) {

    require(['js/lib/models/ModelManager'], function(ModelManager) {
      var $target = $(e.target);
      var $productPurchaseForm = $target.closest('form');
      var productSpin = $productPurchaseForm.children('[name="spin"]').val();
      var $customModelForm = $('form[data-sw-custom-model=' + productSpin + ']');
      var product = ModelManager.getProduct(productSpin);
      var config = product.getCurrentProductConfiguration();
      var action = $customModelForm.attr('action');
      var formData = new FormData($customModelForm[0]);

      // Custom maker currently submits to two different endpoins
      // we only want to to use swAjax for the basic endpoint for now
      var isNormalAddToCart = (action === '/cart/add');
      var ajaxType = isNormalAddToCart ? 'swAjax' : 'ajax';
      var timeout = isNormalAddToCart ? $.swAjax.SW_TIMEOUT_TIME : undefined;

      // don't submit if text is invalid
      var $textInput = $customModelForm.find('[data-sw-custom-model-hotspot-id][type="text"]');
      if(product.isCurrentModelCustomizable() && $textInput.length && (!$textInput.swValidatePattern() || !$textInput.swValidateLength())) {
        notifications.error('Please make sure the custom text you entered is valid.');
        return;
      }

      $productPurchaseForm.find(':input').each(function(index, input) {
        var $input = $(input);
        formData.append($input.attr('name'), $input.val());
      });

      $customModelForm.find('[type=file]').each(function(index, file){
        if(!file.files || !file.files.length){
          return;
        }

        formData.append(file.attributes.name.value, file.files[0]);
      });

      function hideWaiting() {
        $target.removeClass('waiting disabled');
      }

      function addToCart() {
        formData.append('productConfigurationId', config.productConfigurationId);

        $target.addClass('waiting disabled');

        $[ajaxType]({
          type        : $customModelForm.attr('method'),
          url         : $customModelForm.attr('action'),
          data        : formData,
          cache       : false,
          timeout     : timeout,
          contentType : false,
          processData : false,
          retryTimeout: function retryTimeout(jqXHR, textStatus, errorThrown, swInfo) {
            $.swAjax.triggerDefaultRetryNotey(swInfo.retryEventID);
          },
          success: function customModelProductSubmitSuccess(response) {
            var parsedResponse;
            var isJson = false;

            try {
              parsedResponse = window.JSON.parse(response);
              isJson = true;
            } catch(e) {}

            if(sw.data.isEmbed && sw.data.baseUrl) {
              parent.window.location = sw.data.baseUrl + '/cart';
              return;
            }

            if(isJson) {
              $.swPortal.addToCartPopup('/cart/add/ajax', { itemId  : parsedResponse.modelId , materialId : parsedResponse.materialId });
            }
            else {
              sw.trigger('cart-add-product', response, productSpin, {quantity: formData.get('quantity')});
            }
            hideWaiting();

          },
          error: function error(jqXHR, textStatus) {
            hideWaiting();
            if(textStatus !== $.swAjax.ERROR_TYPES.TIMEOUT) {
              $.swAjax.triggerDefaultFailNotey();
            }
          }
        });
      }

      var LOGIN_SUCCESS_EVENT = 'sw-login-complete.custommaker';
      if(!isNormalAddToCart && !sw.data.user.isLoggedIn && !sw.data.customMakerLoginNotRequired) {
        signupDialog.openLogInSignUpDialog('login', null, 'personalize', null, 'event:' + LOGIN_SUCCESS_EVENT);
        sw.on(LOGIN_SUCCESS_EVENT, function () {
          sw.off(LOGIN_SUCCESS_EVENT);
          addToCart();
        });
      } else {
        addToCart();
      }

    });
  });

});
